// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.font-karla-reg {
  font-family: "KarlaRegular";
}

.font-karla-med {
  font-family: "KarlaMedium";
}

.font-inter-reg {
  font-family: "InterRegular";
}

.font-inter-med {
  font-family: "InterMedium";
}

.font-karla {
  font-family: Karla !important;
}

.font-inter {
  font-family: Inter !important;
}

.btn-color {
  background-color: #80b036;
  color: #000;
}

.font-10 {
  font-size: 10px !important;
}

.font-12 {
  font-size: 12px !important;
}

.font-14 {
  font-size: 14px !important;
}

.font-15 {
  font-size: 15px !important;
}

.font-16 {
  font-size: 16px !important;
}

.font-18 {
  font-size: 18px !important;
}

.font-20 {
  font-size: 20px !important;
}

.font-22 {
  font-size: 22px !important;
}

.font-24 {
  font-size: 24px !important;
}

.font-28 {
  font-size: 28px !important;
}

.fw-400 {
  font-weight: 400;
}

.fw-700 {
  font-weight: 700;
}

.project-primary-color {
  color: #45852e !important;
}

.dashboard-text-color {
  color: #323e4a;
}

.screen-text-color {
  color: #333e48;
}

.lh-14 {
  line-height: 14.4px;
}

.lh-19 {
  line-height: 19.6px;
}

.lh-22 {
  line-height: 22.4px;
}

.lh-21 {
  line-height: 21px;
}

.lh-24 {
  line-height: 24px;
}

.lh-25 {
  line-height: 25.2px;
}

.lh-29 {
  line-height: 29.05px;
}

.lh-30 {
  line-height: 30.8px;
}

.ls-02 {
  letter-spacing: -0.02em;
}

.ls-2 {
  letter-spacing: -2%;
}

.border-rad-12 {
  border-radius: 12px;
}

.scroll-up {
  position: fixed;
  bottom: 5%;
  right: 5%;
}

.rotate-class {
  transform: rotate(180deg);
}

.rotate-reverse {
  transform: rotate(0deg);
}

.transition-class {
  transition: transform 0.6s ease-in-out;
}

.icon-active-color {
  color: #323e4a;
}

.icon-inactive-color {
  color: #9ba0a4;
}

.wrapper {
  /* height: 100vh; */
  /* overflow-y: scroll; */
}

.btn-bg-green {
  color: white !important;
  width: 125px !important;
  border-radius: 8px !important;
  background: #45852e !important;
}

input:indeterminate + label {
  background: lime;
}

input[type=checkbox] {
  min-width: 20px;
  height: 20px;
}

input[type=checkbox] {
  position: relative;
  border: 2px solid #45852e;
  border-radius: 4px;
  background: none;
  cursor: pointer;
  line-height: 0;
  margin: 0 0.6em 0 0;
  outline: 0;
  padding: 0 !important;
  vertical-align: text-top;
  height: 20px;
  width: 20px;
  -webkit-appearance: none;
  opacity: 0.5;
}

input[type=checkbox]:hover {
  opacity: 1;
}

input[type=checkbox]:checked {
  background-color: #45852e;
  opacity: 1;
}

input[type=checkbox]:before {
  content: "";
  position: absolute;
  right: 45%;
  top: 45%;
  width: 6px;
  height: 12px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translate(-50%, -50%);
  z-index: 2;
  opacity: 0;
}

input[type=checkbox]:checked::before {
  opacity: 1;
  content: "";
  color: #2b6daf;
}

input[type=checkbox]:indeterminate {
  border: 2px solid white !important;
  background-color: white;
  opacity: 1;
}

input[type=checkbox]:indeterminate::before {
  content: "";
  border: solid #45852e;
  border-width: 0 2px 2px 0;
  opacity: 1 !important;
}

input[type=checkbox].default-checked:checked {
  background-color: #737373; /* Change this to your desired color */
  border: 2px solid #737373;
}

input[type=checkbox].default-checked:not(:checked) {
  background-color: #fff; /* Background color when not checked */
  border: 2px solid rgba(200, 200, 200, 0.8039215686); /* Border color when not checked */
}

input[type=checkbox].default-checked:not(:checked):hover {
  background-color: #fff; /* Background color when not checked */
  border: 2px solid rgba(200, 200, 200, 0.8039215686); /* Border color when not checked */
  opacity: unset;
  cursor: unset;
}

.applicationPage {
  background-color: rgba(0, 0, 0, 0.08) !important;
}

.full-height {
  height: 100vh;
  overflow-y: scroll;
}

.card_border {
  border-radius: 24px;
}

.card_title {
  color: #000;
  font-family: "InterMedium";
  font-size: 25px;
}

.card_subtitle {
  color: #45852e;
  font-family: Inter;
  font-size: 20px;
}

.back_arrow {
  background-color: #efefef;
  position: relative;
}

.back_arrow::after {
  content: "";
  position: absolute;
  inset: 20px 20px;
  width: 15px;
  height: 15px;
  border-radius: 1.8px;
  border-top: 2.5px solid #211e1e;
  border-right: 2.5px solid #100f0f;
  border-bottom: 2px solid transparent;
  border-left: 2px solid transparent;
  transform: rotate(220deg);
}

.back_sqaure {
  width: 50px !important;
  height: 50px !important;
  border-radius: 10px;
  justify-content: flex-start;
  align-items: end;
  background-color: #e0f1da;
}

.text-nav {
  color: rgba(0, 0, 0, 0.4);
  font-size: 12px;
}

.form-group {
  margin-bottom: 25px;
}

.form-group > label {
  display: block;
  font-size: 18px;
  color: #000;
}

.custom-control-label {
  color: #000;
  font-size: 16px;
}

.form-control {
  font-family: Inter;
  height: 50px;
  background: #fff;
  border-color: transparent;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 0 15px !important;
  font-size: 16px;
  transition: all 0.3s ease-in-out;
}

.form-control:focus,
.form-control-focus {
  border-color: #3a7425;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}

textarea.form-control {
  height: 160px;
  padding-top: 15px;
  resize: none;
}

.btn {
  padding: 0.657rem 0.75rem;
  font-size: 18px;
  letter-spacing: 0.05em;
  transition: all 0.3s ease-in-out;
}

.btn-primary:hover {
  color: #00bcd9;
  background-color: #ffffff;
  border-color: #00bcd9;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

.btn-primary:focus,
.btn-primary.focus {
  color: #00bcd9;
  background-color: #ffffff;
  border-color: #00bcd9;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #00bcd9;
  background-color: #ffffff;
  border-color: #00bcd9;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

.stickyCard {
  position: sticky;
  top: 15%;
}

.side_tab {
  cursor: pointer;
  border-radius: 30px;
  color: #6e6e6e;
  height: 56px;
  border-radius: 60px;
  display: flex;
  align-items: center;
}

.side_tab span {
  width: 56px;
  height: 56px;
  border-radius: 50px;
  color: #6e6e6e;
}

.active1 {
  background: #619050;
  color: #ffffff;
  font-weight: 400;
}

.active1 .activeKey {
  border-radius: 50%;
  background: #3a7425;
  color: #ffffff;
  font-weight: 600;
}

.visited {
  background: #eafae1;
  color: #45852e;
  font-weight: 400;
}

.visited .visitedKey {
  border-radius: 50%;
  background: #d0edc5;
  color: #45852e;
  font-weight: 600;
}

.tabs {
  background: #f5f5f5;
  color: #323e4a;
}

.tabs .tabsKey {
  border-radius: 50%;
  background: #ebebeb;
  color: #323e4a;
  font-weight: 600;
}

.form-select:disabled {
  border: 0 !important;
}

.form-control:disabled {
  border: 0 !important;
}

.scrolledNav {
  display: none;
  opacity: 0;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 2px green solid;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: green;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: green;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 6px;
  top: 3px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(35deg);
}

.note {
  background-color: #eaeff7;
  border-color: #2e61b4;
  margin-bottom: 5px;
}
.note i {
  color: #6797e6;
}

.btn-primary:hover {
  background-color: #fff !important;
}

.footer_common.fixed-bottom.footerBtnPatch {
  z-index: 1000;
}

.jodit-wysiwyg {
  min-height: 400px !important;
}

.jodit-container {
  max-width: 90% !important;
}

.jodit-container-wrapper {
  transform: scale(1.111); /* 100 / 90 = 1.111 */
  transform-origin: top left;
}

.sub-text-style {
  font-size: 14px;
  font-weight: 500;
  line-height: 19.6px;
  text-align: left;
  color: #0763b8;
}

.modal-backdrop.show {
  height: 100% !important;
  width: 100% !important;
}

.placeholder-style {
  color: #212529 !important;
}

.react-select__control--is-focused {
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1) !important;
}

.form-border-rad {
  border-radius: 10px !important;
  min-height: 50px !important;
  max-height: fit-content !important;
  height: 100% !important;
  border-color: #d9d9d9;
  margin-top: 5.2px;
}

.option-on-focus {
  background-color: rgb(236, 242, 233) !important;
  color: #000 !important;
  padding: 0px 12px !important;
  font-size: 16px !important;
}

.option-style {
  padding: 0px 12px !important;
  font-size: 16px !important;
  color: #212529 !important;
}

.menu-style {
  max-width: 100% !important;
  min-width: 100% !important;
  border-radius: 10px !important;
  font-family: Inter;
  background-color: hsl(0, 0%, 100%);
  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);
  z-index: 9999 !important;
}

.search-menu-list {
  max-height: 300px;
  overflow-y: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 4px;
  padding-top: 4px;
  box-sizing: border-box;
}

.select-multi-value-label {
  border-radius: 2px;
  color: hsl(0, 0%, 20%);
  font-size: 85%;
  padding: 3px;
  padding-left: 6px;
}

.select-multi-value {
  background-color: hsl(0, 0%, 90%);
  border-radius: 2px;
  margin: 2px;
}

.select-dropdown-indicator,
.select-clear-indicator {
  color: hsl(0, 0%, 80%);
}

.select-multi-value-remove {
  border-radius: 2px;
  padding-left: 4px;
  padding-right: 4px;
}

.search-loading-message {
  text-align: center;
  color: hsl(0, 0%, 60%);
  padding: 8px 12px;
  box-sizing: border-box;
}

.date-picker::placeholder {
  color: #212529;
}

.single-option-style {
  font-size: 16px !important;
  color: #212529 !important;
}

.typeof-plot-details {
  line-height: 25.6px;
  letter-spacing: -0.02em;
  color: #323e4a;
}

.checklist-outer .collapsible_box.collapsible_box_checklist {
  background-color: #f6f6f6;
}
.checklist-outer .collapsible_box.collapsible_box_checklist input[type=checkbox]:checked + label {
  color: #000;
  background-color: transparent;
  padding-bottom: 15px !important;
}
.checklist-outer .collapsible_box.collapsible_box_checklist input[type=checkbox]:checked + label::after {
  background-color: #000;
}
.checklist-outer .collapsible_box.collapsible_box_checklist .collapsible_box_label {
  background-color: transparent;
}

.font-green {
  color: #45852e;
}

.font-black {
  color: #000;
}

.table-column-checkbox input[type=checkbox] {
  border: 2px solid white;
}
.table-column-checkbox input[type=checkbox]::before {
  content: "";
  border: solid #45852e;
  border-width: 0 2px 2px 0;
}
.table-column-checkbox input[type=checkbox]:checked {
  background-color: white;
}

.table-column-seprator {
  border-right: 1px solid rgba(255, 255, 255, 0.3607843137);
}
.table-column-seprator:last-child {
  border-right: none;
}

.column-text-start {
  text-align: left !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.column-text-end {
  text-align: right !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}

.pad-y-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.px-05 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.arrear-breakdown {
  background: #f5f5f6;
}
.arrear-breakdown .main span {
  color: #45852e;
  line-height: 22.4px;
}
.arrear-breakdown .total span {
  line-height: 22.4px;
  color: #404040;
}
.arrear-breakdown .sub-main span {
  font-weight: 400;
  line-height: 19.6px;
  color: rgba(0, 0, 0, 0.6);
}

.send-back-card {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 116px;
  margin-left: 5px;
}
.send-back-card .dropdown-text {
  padding: 8px 12px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.send-back-card .dropdown-text:hover {
  background-color: rgba(235, 235, 235, 0.4784313725);
}

.existing-plot-details {
  border-bottom: 1px solid #cfcfcf;
}
.existing-plot-details:last-child {
  border-bottom: none;
}
.existing-plot-details .title {
  line-height: 19.2px;
  color: rgba(0, 0, 0, 0.8);
}

.apply-plot-screen-parents .plot-screen-main-card {
  background: linear-gradient(0deg, #ffffff 0%, rgba(115, 187, 89, 0.168627451) 100%);
}
.apply-plot-screen-parents .water-screen-main-card {
  background: linear-gradient(0deg, #ffffff 0%, #e8eef6 100%);
}
.apply-plot-screen-parents .user-screen-main-card {
  background: linear-gradient(0deg, #ffffff 0%, #faefea 100%);
}
.apply-plot-screen-parents .action-cards {
  background: #eff0f1;
  border: 1px solid #cdd5d8;
}
.apply-plot-screen-parents .action-cards:hover {
  background: #edf4ea;
}

.dashboard-select-menu-style {
  z-index: 1000 !important;
}
.dashboard-select-menu-style .fy-options {
  background-color: rgb(236, 242, 233) !important;
  color: #000 !important;
}

.checkbox-container input:checked ~ .checkmarkDefault {
  background-color: #737373;
}

.checkmarkDefault:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmarkDefault:after {
  display: block;
}

.checkbox-container .checkmarkDefault:after {
  left: 6px;
  top: 3px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(35deg);
}

.checkmarkDefault {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 2px #737373 solid;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: green;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: green;
}

.checkbox-container input:checked ~ .checkmarkDefault {
  background-color: #737373;
}

.declaration-note {
  border: 0.74px solid #c44744;
  background: #f7eaea;
}

.gsr-scrren-download-section {
  border: 1px solid #3370d4;
  background: rgba(7, 99, 184, 0.1019607843);
}
.gsr-scrren-download-section span:first-of-type {
  color: #282828;
}
.gsr-scrren-download-section span:nth-of-type(2) {
  color: #0763b8;
}

.serial-no {
  width: 9%;
}

.dpr-column {
  width: 13%;
}

.search-field-disabled {
  background: #e9ecef;
}

.dpr-search-column {
  width: 15%;
}

.dpr-serail-no {
  width: 10%;
}

.text-disable {
  color: #c8c8c8;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,cAAA;EACA,oBAAA;AACJ;;AAEA;EACI;IACI,4CAAA;EACN;AACF;AAEA;EACI,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI;IACI,uBAAA;EAAN;EAGE;IACI,yBAAA;EADN;AACF;AAIA;EACI,2BAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,2BAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,6BAAA;AAFJ;;AAKA;EACI,6BAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,WAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAIA;EACI,0BAAA;AADJ;;AAIA;EACI,0BAAA;AADJ;;AAIA;EACI,0BAAA;AADJ;;AAGA;EACI,0BAAA;AAAJ;;AAGA;EACI,0BAAA;AAAJ;;AAEA;EACI,0BAAA;AACJ;;AACA;EACI,gBAAA;AAEJ;;AAAA;EACI,gBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AAFA;EACI,cAAA;AAKJ;;AAHA;EACI,cAAA;AAMJ;;AAJA;EACI,mBAAA;AAOJ;;AALA;EACI,mBAAA;AAQJ;;AANA;EACI,mBAAA;AASJ;;AAPA;EACI,iBAAA;AAUJ;;AARA;EACI,iBAAA;AAWJ;;AATA;EACI,mBAAA;AAYJ;;AAVA;EACI,oBAAA;AAaJ;;AAXA;EACI,mBAAA;AAcJ;;AAZA;EACI,uBAAA;AAeJ;;AAbA;EACI,mBAAA;AAgBJ;;AAdA;EACI,mBAAA;AAiBJ;;AAfA;EACI,eAAA;EACA,UAAA;EACA,SAAA;AAkBJ;;AAhBA;EACI,yBAAA;AAmBJ;;AAjBA;EACI,uBAAA;AAoBJ;;AAlBA;EACI,sCAAA;AAqBJ;;AAnBA;EACI,cAAA;AAsBJ;;AApBA;EACI,cAAA;AAuBJ;;AArBA;EACI,mBAAA;EACA,wBAAA;AAwBJ;;AArBA;EACI,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;AAwBJ;;AArBA;EACI,gBAAA;AAwBJ;;AArBA;EACI,eAAA;EACA,YAAA;AAwBJ;;AArBA;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;AAwBJ;;AArBA;EACI,UAAA;AAwBJ;;AArBA;EACI,yBAAA;EACA,UAAA;AAwBJ;;AArBA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,8CAAA;EACA,UAAA;EACA,UAAA;AAwBJ;;AAtBA;EACI,UAAA;EACA,WAAA;EACA,cAAA;AAyBJ;;AAtBA;EACI,kCAAA;EACA,uBAAA;EACA,UAAA;AAyBJ;;AAtBA;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAyBJ;;AAtBA;EACI,yBAAA,EAAA,sCAAA;EACA,yBAAA;AAyBJ;;AAtBA;EACI,sBAAA,EAAA,sCAAA;EACA,mDAAA,EAAA,kCAAA;AAyBJ;;AAtBA;EACI,sBAAA,EAAA,sCAAA;EACA,mDAAA,EAAA,kCAAA;EACA,cAAA;EACA,aAAA;AAyBJ;;AAtBA;EACI,gDAAA;AAyBJ;;AAtBA;EACI,aAAA;EACA,kBAAA;AAyBJ;;AAtBA;EACI,mBAAA;AAyBJ;;AAtBA;EACI,WAAA;EACA,0BAAA;EACA,eAAA;AAyBJ;;AAtBA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;AAyBJ;;AAtBA;EACI,yBAAA;EACA,kBAAA;AAyBJ;;AAtBA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,oCAAA;EACA,kCAAA;EACA,yBAAA;AAyBJ;;AAtBA;EACI,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;AAyBJ;;AAtBA;EACI,yBAAA;EACA,eAAA;AAyBJ;;AAtBA;EACI,mBAAA;AAyBJ;;AAtBA;EACI,cAAA;EACA,eAAA;EACA,WAAA;AAyBJ;;AAtBA;EACI,WAAA;EACA,eAAA;AAyBJ;;AAtBA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EAIA,gCAAA;AAyBJ;;AAtBA;;EAEI,qBAAA;EAGA,0CAAA;AAyBJ;;AAtBA;EACI,aAAA;EACA,iBAAA;EACA,YAAA;AAyBJ;;AAtBA;EACI,yBAAA;EACA,eAAA;EACA,sBAAA;EAIA,gCAAA;AAyBJ;;AAtBA;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;EAGA,2CAAA;AAyBJ;;AAtBA;;EAEI,cAAA;EACA,yBAAA;EACA,qBAAA;EAGA,2CAAA;AAyBJ;;AAtBA;;;EAGI,cAAA;EACA,yBAAA;EACA,qBAAA;AAyBJ;;AAtBA;;;EAKI,2CAAA;AAyBJ;;AAtBA;EAEI,gBAAA;EACA,QAAA;AAyBJ;;AAtBA;EACI,eAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAyBJ;;AAtBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAyBJ;;AAtBA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;AAyBJ;;AAtBA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAyBJ;;AAvBA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;AA0BJ;;AAxBA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA2BJ;;AAzBA;EACI,mBAAA;EACA,cAAA;AA4BJ;;AA1BA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA6BJ;;AA1BA;EACI,oBAAA;AA6BJ;;AA1BA;EACI,oBAAA;AA6BJ;;AA1BA;EACI,aAAA;EACA,UAAA;AA6BJ;;AA1BA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;AA6BJ;;AA1BA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AA6BJ;;AA1BA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EAEA,uBAAA;AA4BJ;;AAzBA;EACI,uBAAA;AA4BJ;;AAzBA;EACI,uBAAA;AA4BJ;;AAzBA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AA4BJ;;AAzBA;EACI,cAAA;AA4BJ;;AAzBA;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AA4BJ;;AAzBA;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;AA4BJ;AA1BI;EACI,cAAA;AA4BR;;AAxBA;EACI,iCAAA;AA2BJ;;AAzBA;EACI,aAAA;AA4BJ;;AAzBA;EACI,4BAAA;AA4BJ;;AAzBA;EACI,yBAAA;AA4BJ;;AAzBA;EACI,uBAAA,EAAA,qBAAA;EACA,0BAAA;AA4BJ;;AAzBA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AA4BJ;;AAzBA;EACI,uBAAA;EACA,sBAAA;AA4BJ;;AA1BA;EACI,yBAAA;AA6BJ;;AA3BA;EAGI,qDAAA;AA8BJ;;AA5BA;EACI,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;AA+BJ;;AA7BA;EACI,+CAAA;EACA,sBAAA;EACA,4BAAA;EACA,0BAAA;AAgCJ;;AA7BA;EACI,4BAAA;EACA,0BAAA;EACA,yBAAA;AAgCJ;;AA9BA;EACI,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,kBAAA;EACA,kCAAA;EACA,2EACI;EAEJ,wBAAA;AA+BJ;;AA7BA;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAgCJ;;AA9BA;EACI,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AAiCJ;;AA/BA;EACI,iCAAA;EACA,kBAAA;EACA,WAAA;AAkCJ;;AAhCA;;EAEI,sBAAA;AAmCJ;;AAjCA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;AAoCJ;;AAlCA;EACI,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;AAqCJ;;AAnCA;EACI,cAAA;AAsCJ;;AApCA;EACI,0BAAA;EACA,yBAAA;AAuCJ;;AArCA;EACI,mBAAA;EACA,uBAAA;EACA,cAAA;AAwCJ;;AArCI;EACI,yBAAA;AAwCR;AAvCQ;EACI,WAAA;EACA,6BAAA;EACA,+BAAA;AAyCZ;AAxCY;EACI,sBAAA;AA0ChB;AAvCQ;EACI,6BAAA;AAyCZ;;AApCA;EACI,cAAA;AAuCJ;;AApCA;EACI,WAAA;AAuCJ;;AArCA;EACI,uBAAA;AAwCJ;AAvCI;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;AAyCR;AAvCI;EACI,uBAAA;AAyCR;;AArCA;EACI,yDAAA;AAwCJ;AAvCI;EACI,kBAAA;AAyCR;;AAtCA;EACI,2BAAA;EACA,6BAAA;EACA,8BAAA;AAyCJ;;AAvCA;EACI,4BAAA;EACA,8BAAA;EACA,6BAAA;AA0CJ;;AAvCA;EACI,2BAAA;EACA,8BAAA;AA0CJ;;AAvCA;EACI,oBAAA;EACA,qBAAA;AA0CJ;;AAxCA;EACI,mBAAA;AA2CJ;AAzCQ;EACI,cAAA;EACA,mBAAA;AA2CZ;AAvCQ;EACI,mBAAA;EACA,cAAA;AAyCZ;AArCQ;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;AAuCZ;;AAnCA;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,sBAAA;EACA,wCAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAsCJ;AArCI;EACI,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAuCR;AAtCQ;EACI,mDAAA;AAwCZ;;AApCA;EACI,gCAAA;AAuCJ;AArCI;EACI,mBAAA;AAuCR;AApCI;EACI,mBAAA;EACA,yBAAA;AAsCR;;AAlCI;EACI,mFAAA;AAqCR;AAnCI;EACI,2DAAA;AAqCR;AAnCI;EACI,2DAAA;AAqCR;AAnCI;EACI,mBAAA;EACA,yBAAA;AAqCR;AApCQ;EACI,mBAAA;AAsCZ;;AAlCA;EACI,wBAAA;AAqCJ;AApCI;EACI,+CAAA;EACA,sBAAA;AAsCR;;AAlCA;EACI,yBAAA;AAqCJ;;AAlCA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AAqCJ;;AAlCA;EACI,cAAA;AAqCJ;;AAlCA;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AAqCJ;;AAlCA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AAqCJ;;AAnCA;EACI,uBAAA;AAsCJ;;AApCA;EACI,uBAAA;AAuCJ;;AArCA;EACI,yBAAA;AAwCJ;;AAtCA;EACI,4BAAA;EACA,mBAAA;AAyCJ;;AAvCA;EACI,yBAAA;EACA,0CAAA;AA0CJ;AAxCI;EACI,cAAA;AA0CR;AAxCI;EACI,cAAA;AA0CR;;AAtCA;EACI,SAAA;AAyCJ;;AAtCA;EACI,UAAA;AAyCJ;;AAtCA;EACI,mBAAA;AAyCJ;;AAtCA;EACI,UAAA;AAyCJ;;AAtCA;EACI,UAAA;AAyCJ;;AAtCA;EACI,cAAA;AAyCJ","sourcesContent":[".App {\n    text-align: center;\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.font-karla-reg {\n    font-family: 'KarlaRegular';\n}\n\n.font-karla-med {\n    font-family: 'KarlaMedium';\n}\n\n.font-inter-reg {\n    font-family: 'InterRegular';\n}\n\n.font-inter-med {\n    font-family: 'InterMedium';\n}\n\n.font-karla {\n    font-family: Karla !important;\n}\n\n.font-inter {\n    font-family: Inter !important;\n}\n\n.btn-color {\n    background-color: #80b036;\n    color: #000;\n}\n\n.font-10 {\n    font-size: 10px !important;\n}\n\n.font-12 {\n    font-size: 12px !important;\n}\n\n.font-14 {\n    font-size: 14px !important;\n}\n\n.font-15 {\n    font-size: 15px !important;\n}\n.font-16 {\n    font-size: 16px !important;\n}\n\n.font-18 {\n    font-size: 18px !important;\n}\n\n.font-20 {\n    font-size: 20px !important;\n}\n.font-22 {\n    font-size: 22px !important;\n}\n\n.font-24 {\n    font-size: 24px !important;\n}\n.font-28 {\n    font-size: 28px !important;\n}\n.fw-400 {\n    font-weight: 400;\n}\n.fw-700 {\n    font-weight: 700;\n}\n.project-primary-color {\n    color: #45852e !important;\n}\n.dashboard-text-color {\n    color: #323e4a;\n}\n.screen-text-color {\n    color: #333e48;\n}\n.lh-14 {\n    line-height: 14.4px;\n}\n.lh-19 {\n    line-height: 19.6px;\n}\n.lh-22 {\n    line-height: 22.4px;\n}\n.lh-21 {\n    line-height: 21px;\n}\n.lh-24 {\n    line-height: 24px;\n}\n.lh-25 {\n    line-height: 25.2px;\n}\n.lh-29 {\n    line-height: 29.05px;\n}\n.lh-30 {\n    line-height: 30.8px;\n}\n.ls-02 {\n    letter-spacing: -0.02em;\n}\n.ls-2 {\n    letter-spacing: -2%;\n}\n.border-rad-12 {\n    border-radius: 12px;\n}\n.scroll-up {\n    position: fixed;\n    bottom: 5%;\n    right: 5%;\n}\n.rotate-class {\n    transform: rotate(180deg);\n}\n.rotate-reverse {\n    transform: rotate(0deg);\n}\n.transition-class {\n    transition: transform 0.6s ease-in-out;\n}\n.icon-active-color {\n    color: #323e4a;\n}\n.icon-inactive-color {\n    color: #9ba0a4;\n}\n.wrapper {\n    /* height: 100vh; */\n    /* overflow-y: scroll; */\n}\n\n.btn-bg-green {\n    color: white !important;\n    width: 125px !important;\n    border-radius: 8px !important;\n    background: #45852e !important;\n}\n\ninput:indeterminate + label {\n    background: lime;\n}\n\ninput[type='checkbox'] {\n    min-width: 20px;\n    height: 20px;\n}\n\ninput[type='checkbox'] {\n    position: relative;\n    border: 2px solid #45852e;\n    border-radius: 4px;\n    background: none;\n    cursor: pointer;\n    line-height: 0;\n    margin: 0 0.6em 0 0;\n    outline: 0;\n    padding: 0 !important;\n    vertical-align: text-top;\n    height: 20px;\n    width: 20px;\n    -webkit-appearance: none;\n    opacity: 0.5;\n}\n\ninput[type='checkbox']:hover {\n    opacity: 1;\n}\n\ninput[type='checkbox']:checked {\n    background-color: #45852e;\n    opacity: 1;\n}\n\ninput[type='checkbox']:before {\n    content: '';\n    position: absolute;\n    right: 45%;\n    top: 45%;\n    width: 6px;\n    height: 12px;\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg) translate(-50%, -50%);\n    z-index: 2;\n    opacity: 0;\n}\ninput[type='checkbox']:checked::before {\n    opacity: 1;\n    content: '';\n    color: #2b6daf;\n}\n\ninput[type='checkbox']:indeterminate {\n    border: 2px solid white !important;\n    background-color: white;\n    opacity: 1;\n}\n\ninput[type='checkbox']:indeterminate::before {\n    content: '';\n    border: solid #45852e;\n    border-width: 0 2px 2px 0;\n    opacity: 1 !important;\n}\n\ninput[type='checkbox'].default-checked:checked {\n    background-color: #737373; /* Change this to your desired color */\n    border: 2px solid #737373;\n}\n\ninput[type='checkbox'].default-checked:not(:checked) {\n    background-color: #fff; /* Background color when not checked */\n    border: 2px solid #c8c8c8cd; /* Border color when not checked */\n}\n\ninput[type='checkbox'].default-checked:not(:checked):hover {\n    background-color: #fff; /* Background color when not checked */\n    border: 2px solid #c8c8c8cd; /* Border color when not checked */\n    opacity: unset;\n    cursor: unset;\n}\n\n.applicationPage {\n    background-color: rgba(0, 0, 0, 0.08) !important;\n}\n\n.full-height {\n    height: 100vh;\n    overflow-y: scroll;\n}\n\n.card_border {\n    border-radius: 24px;\n}\n\n.card_title {\n    color: #000;\n    font-family: 'InterMedium';\n    font-size: 25px;\n}\n\n.card_subtitle {\n    color: #45852e;\n    font-family: Inter;\n    font-size: 20px;\n}\n\n.back_arrow {\n    background-color: #efefef;\n    position: relative;\n}\n\n.back_arrow::after {\n    content: '';\n    position: absolute;\n    inset: 20px 20px;\n    width: 15px;\n    height: 15px;\n    border-radius: 1.8px;\n    border-top: 2.5px solid #211e1e;\n    border-right: 2.5px solid #100f0f;\n    border-bottom: 2px solid transparent;\n    border-left: 2px solid transparent;\n    transform: rotate(220deg);\n}\n\n.back_sqaure {\n    width: 50px !important;\n    height: 50px !important;\n    border-radius: 10px;\n    justify-content: flex-start;\n    align-items: end;\n    background-color: #e0f1da;\n}\n\n.text-nav {\n    color: rgba(0, 0, 0, 0.4);\n    font-size: 12px;\n}\n\n.form-group {\n    margin-bottom: 25px;\n}\n\n.form-group > label {\n    display: block;\n    font-size: 18px;\n    color: #000;\n}\n\n.custom-control-label {\n    color: #000;\n    font-size: 16px;\n}\n\n.form-control {\n    font-family: Inter;\n    height: 50px;\n    background: #fff;\n    border-color: transparent;\n    border: 1px solid #d9d9d9;\n    border-radius: 10px;\n    padding: 0 15px !important;\n    font-size: 16px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n\n.form-control:focus,\n.form-control-focus {\n    border-color: #3a7425;\n    -webkit-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n}\n\ntextarea.form-control {\n    height: 160px;\n    padding-top: 15px;\n    resize: none;\n}\n\n.btn {\n    padding: 0.657rem 0.75rem;\n    font-size: 18px;\n    letter-spacing: 0.05em;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n\n.btn-primary:hover {\n    color: #00bcd9;\n    background-color: #ffffff;\n    border-color: #00bcd9;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary:focus,\n.btn-primary.focus {\n    color: #00bcd9;\n    background-color: #ffffff;\n    border-color: #00bcd9;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary:not(:disabled):not(.disabled):active,\n.btn-primary:not(:disabled):not(.disabled).active,\n.show > .btn-primary.dropdown-toggle {\n    color: #00bcd9;\n    background-color: #ffffff;\n    border-color: #00bcd9;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n}\n\n.stickyCard {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 15%;\n}\n\n.side_tab {\n    cursor: pointer;\n    border-radius: 30px;\n    color: #6e6e6e;\n    height: 56px;\n    border-radius: 60px;\n    display: flex;\n    align-items: center;\n}\n\n.side_tab span {\n    width: 56px;\n    height: 56px;\n    border-radius: 50px;\n    color: #6e6e6e;\n}\n\n.active1 {\n    background: #619050;\n    color: #ffffff;\n    font-weight: 400;\n}\n\n.active1 .activeKey {\n    border-radius: 50%;\n    background: #3a7425;\n    color: #ffffff;\n    font-weight: 600;\n}\n.visited {\n    background: #eafae1;\n    color: #45852e;\n    font-weight: 400;\n}\n.visited .visitedKey {\n    border-radius: 50%;\n    background: #d0edc5;\n    color: #45852e;\n    font-weight: 600;\n}\n.tabs {\n    background: #f5f5f5;\n    color: #323e4a;\n}\n.tabs .tabsKey {\n    border-radius: 50%;\n    background: #ebebeb;\n    color: #323e4a;\n    font-weight: 600;\n}\n\n.form-select:disabled {\n    border: 0 !important;\n}\n\n.form-control:disabled {\n    border: 0 !important;\n}\n\n.scrolledNav {\n    display: none;\n    opacity: 0;\n}\n\n.checkbox-container {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.checkbox-container input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 20px;\n    width: 20px;\n\n    border: 2px green solid;\n}\n\n.checkbox-container:hover input ~ .checkmark {\n    background-color: green;\n}\n\n.checkbox-container input:checked ~ .checkmark {\n    background-color: green;\n}\n\n.checkmark:after {\n    content: '';\n    position: absolute;\n    display: none;\n}\n\n.checkbox-container input:checked ~ .checkmark:after {\n    display: block;\n}\n\n.checkbox-container .checkmark:after {\n    left: 6px;\n    top: 3px;\n    width: 5px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(35deg);\n    -ms-transform: rotate(35deg);\n    transform: rotate(35deg);\n}\n\n.note {\n    background-color: #eaeff7;\n    border-color: #2e61b4;\n    margin-bottom: 5px;\n\n    i {\n        color: #6797e6;\n    }\n}\n\n.btn-primary:hover {\n    background-color: #fff !important;\n}\n.footer_common.fixed-bottom.footerBtnPatch {\n    z-index: 1000;\n}\n\n.jodit-wysiwyg {\n    min-height: 400px !important;\n}\n\n.jodit-container {\n    max-width: 90% !important;\n}\n\n.jodit-container-wrapper {\n    transform: scale(1.111); /* 100 / 90 = 1.111 */\n    transform-origin: top left;\n}\n\n.sub-text-style {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 19.6px;\n    text-align: left;\n    color: #0763b8;\n}\n// modal\n.modal-backdrop.show {\n    height: 100% !important;\n    width: 100% !important;\n}\n.placeholder-style {\n    color: #212529 !important;\n}\n.react-select__control--is-focused {\n    -webkit-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1) !important ;\n    -moz-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1) !important ;\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1) !important;\n}\n.form-border-rad {\n    border-radius: 10px !important;\n    min-height: 50px !important;\n    max-height: fit-content !important;\n    height: 100% !important;\n    border-color: #d9d9d9;\n    margin-top: 5.2px;\n}\n.option-on-focus {\n    background-color: rgb(236, 242, 233) !important;\n    color: #000 !important;\n    padding: 0px 12px !important;\n    font-size: 16px !important;\n}\n\n.option-style {\n    padding: 0px 12px !important;\n    font-size: 16px !important;\n    color: #212529 !important;\n}\n.menu-style {\n    max-width: 100% !important;\n    min-width: 100% !important;\n    border-radius: 10px !important;\n    font-family: Inter;\n    background-color: hsl(0, 0%, 100%);\n    box-shadow:\n        0 0 0 1px hsla(0, 0%, 0%, 0.1),\n        0 4px 11px hsla(0, 0%, 0%, 0.1);\n    z-index: 9999 !important;\n}\n.search-menu-list {\n    max-height: 300px;\n    overflow-y: auto;\n    position: relative;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 4px;\n    padding-top: 4px;\n    box-sizing: border-box;\n}\n.select-multi-value-label {\n    border-radius: 2px;\n    color: hsl(0, 0%, 20%);\n    font-size: 85%;\n    padding: 3px;\n    padding-left: 6px;\n}\n.select-multi-value {\n    background-color: hsl(0, 0%, 90%);\n    border-radius: 2px;\n    margin: 2px;\n}\n.select-dropdown-indicator,\n.select-clear-indicator {\n    color: hsl(0, 0%, 80%);\n}\n.select-multi-value-remove {\n    border-radius: 2px;\n    padding-left: 4px;\n    padding-right: 4px;\n}\n.search-loading-message {\n    text-align: center;\n    color: hsl(0, 0%, 60%);\n    padding: 8px 12px;\n    box-sizing: border-box;\n}\n.date-picker::placeholder {\n    color: #212529;\n}\n.single-option-style {\n    font-size: 16px !important;\n    color: #212529 !important;\n}\n.typeof-plot-details {\n    line-height: 25.6px;\n    letter-spacing: -0.02em;\n    color: #323e4a;\n}\n.checklist-outer {\n    .collapsible_box.collapsible_box_checklist {\n        background-color: #f6f6f6;\n        input[type='checkbox']:checked + label {\n            color: #000;\n            background-color: transparent;\n            padding-bottom: 15px !important;\n            &::after {\n                background-color: #000;\n            }\n        }\n        .collapsible_box_label {\n            background-color: transparent;\n        }\n    }\n}\n\n.font-green {\n    color: #45852e;\n}\n\n.font-black {\n    color: #000;\n}\n.table-column-checkbox input[type='checkbox'] {\n    border: 2px solid white;\n    &::before {\n        content: '';\n        border: solid #45852e;\n        border-width: 0 2px 2px 0;\n    }\n    &:checked {\n        background-color: white;\n    }\n}\n\n.table-column-seprator {\n    border-right: 1px solid #ffffff5c;\n    &:last-child {\n        border-right: none;\n    }\n}\n.column-text-start {\n    text-align: left !important;\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n}\n.column-text-end {\n    text-align: right !important;\n    padding-right: 15px !important;\n    padding-left: 15px !important;\n}\n\n.pad-y-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n}\n\n.px-05 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n}\n.arrear-breakdown {\n    background: #f5f5f6;\n    .main {\n        span {\n            color: #45852e;\n            line-height: 22.4px;\n        }\n    }\n    .total {\n        span {\n            line-height: 22.4px;\n            color: #404040;\n        }\n    }\n    .sub-main {\n        span {\n            font-weight: 400;\n            line-height: 19.6px;\n            color: #00000099;\n        }\n    }\n}\n.send-back-card {\n    position: absolute;\n    bottom: 0;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    width: 116px;\n    margin-left: 5px;\n    .dropdown-text {\n        padding: 8px 12px;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        &:hover {\n            background-color: #ebebeb7a;\n        }\n    }\n}\n.existing-plot-details {\n    border-bottom: 1px solid #cfcfcf;\n\n    &:last-child {\n        border-bottom: none;\n    }\n\n    .title {\n        line-height: 19.2px;\n        color: #000000cc;\n    }\n}\n.apply-plot-screen-parents {\n    .plot-screen-main-card {\n        background: linear-gradient(0deg, #ffffff 0%, #73bb592b 100%);\n    }\n    .water-screen-main-card {\n        background: linear-gradient(0deg, #ffffff 0%, #e8eef6 100%);\n    }\n    .user-screen-main-card {\n        background: linear-gradient(0deg, #ffffff 0%, #faefea 100%);\n    }\n    .action-cards {\n        background: #eff0f1;\n        border: 1px solid #cdd5d8;\n        &:hover {\n            background: #edf4ea;\n        }\n    }\n}\n.dashboard-select-menu-style {\n    z-index: 1000 !important;\n    .fy-options {\n        background-color: rgb(236, 242, 233) !important;\n        color: #000 !important;\n    }\n}\n\n.checkbox-container input:checked ~ .checkmarkDefault {\n    background-color: #737373;\n}\n\n.checkmarkDefault:after {\n    content: '';\n    position: absolute;\n    display: none;\n}\n\n.checkbox-container input:checked ~ .checkmarkDefault:after {\n    display: block;\n}\n\n.checkbox-container .checkmarkDefault:after {\n    left: 6px;\n    top: 3px;\n    width: 5px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(35deg);\n    -ms-transform: rotate(35deg);\n    transform: rotate(35deg);\n}\n\n.checkmarkDefault {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    border: 2px #737373 solid;\n}\n.checkbox-container:hover input ~ .checkmark {\n    background-color: green;\n}\n.checkbox-container input:checked ~ .checkmark {\n    background-color: green;\n}\n.checkbox-container input:checked ~ .checkmarkDefault {\n    background-color: #737373;\n}\n.declaration-note {\n    border: 0.74px solid #c44744;\n    background: #f7eaea;\n}\n.gsr-scrren-download-section {\n    border: 1px solid #3370d4;\n    background: #0763b81a;\n\n    span:first-of-type {\n        color: #282828;\n    }\n    span:nth-of-type(2) {\n        color: #0763b8;\n    }\n}\n\n.serial-no {\n    width: 9%;\n}\n\n.dpr-column {\n    width: 13%;\n}\n\n.search-field-disabled {\n    background: #e9ecef;\n}\n\n.dpr-search-column {\n    width: 15%;\n}\n\n.dpr-serail-no {\n    width: 10%;\n}\n\n.text-disable {\n    color: #c8c8c8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
